import type { StorageFile, StorageReadDisposition, StorageVisibility } from "@gencow/core";

const PUBLIC_INLINE_CONTENT_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
  "image/avif",
  "image/gif",
]);

export type StorageCacheScope = "public" | "private";

export function normalizeStorageVisibility(value: unknown): StorageVisibility {
  return value === "public" ? "public" : "private";
}

export function isPublicStorageFile(meta: Pick<StorageFile, "visibility">): boolean {
  return normalizeStorageVisibility(meta.visibility) === "public";
}

export function isSafePublicInlineContentType(contentType: string): boolean {
  return PUBLIC_INLINE_CONTENT_TYPES.has(contentType.trim().toLowerCase());
}

export function resolveStorageDisposition(input: {
  meta: StorageFile;
  requested: StorageReadDisposition;
  cacheScope: StorageCacheScope;
}): StorageReadDisposition {
  if (input.cacheScope !== "public") return input.requested;
  if (input.requested !== "inline") return input.requested;
  return isSafePublicInlineContentType(input.meta.type) ? "inline" : "attachment";
}

export function storageCacheControl(scope: StorageCacheScope, privateMaxAgeSeconds = 300): string {
  if (scope === "public") return "public, max-age=31536000, immutable";
  const maxAge = Math.max(0, Math.min(300, Math.floor(privateMaxAgeSeconds)));
  return maxAge > 0 ? `private, max-age=${maxAge}` : "private, no-store";
}
